import type { CommentBody as CommentBodyType, CommentReaction } from '@liveblocks/client'
import type { ComposerSubmitComment } from '@liveblocks/react-ui/primitives'

import { CommentBody } from './comment-body'
import { CommentEditComposer } from './comment-edit-composer'
import { CommentReactions } from './comment-reactions'

type CommentItemContentProps = {
  isEditing: boolean
  body: CommentBodyType
  reactions: readonly CommentReaction[]
  currentUserId?: string
  readOnly?: boolean
  onSave: (comment: ComposerSubmitComment) => void
  onToggleReaction: (emoji: string, reacted: boolean) => void
  onCancelEdit: () => void
}

export const CommentItemContent = ({
  isEditing,
  body,
  reactions,
  currentUserId,
  readOnly,
  onSave,
  onToggleReaction,
  onCancelEdit,
}: CommentItemContentProps) => {
  if (isEditing) {
    return <CommentEditComposer defaultValue={body} onSave={onSave} onCancel={onCancelEdit} />
  }

  return (
    <div className='flex flex-col gap-1.5'>
      <CommentBody body={body} />
      <CommentReactions
        reactions={reactions}
        currentUserId={currentUserId}
        readOnly={readOnly}
        onToggle={onToggleReaction}
      />
    </div>
  )
}
